import { Divider, Grid, Paper, TextField } from "@mui/material";
import { InputText, Modal } from "../../../components";
import ButtonComponent from "../../../components/ButtonComponent";
import { useEffect, useState } from "react";
import ModalComponent from "../../../components/MDModal";
import formatName from "../../../helpers/formatName";
import MaskCPFCNPJ from "../../../helpers/maskCpfCnpj";
import { formatCelular } from "../../../helpers";
import { removeDots } from "../../../helpers/removeDots";
import Loading from "../../../components/Loading";
import { ActionCadatrarUsuario } from "../../../store/actions/usuarios";

function ModalAddEmpresa({ open, close, updateList }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    nome: "",
    password: "",
    email: "",
    tipo: "",
  });

  const [mesageErro, setMessageErro] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setMessageErro("");
    }, 3000);
  }, [mesageErro]);

  async function AddCompany() {
    setLoading(true);
    const _data = {
      nome: data.nome,
      password: data.password,
      email: data.email,
      tipo: "TRIAGEM"
    };
    try {
      await ActionCadatrarUsuario(_data);
      updateList();
      setData({ nome: "", cnpj: "", email: "", celular: "" });
      setLoading(false);
      close();
    } catch (e) {
      console.log(e.response.data.titulo);
      setMessageErro(e?.response?.data?.titulo);
      setLoading(false);
    }
  }

  return (
    <ModalComponent open={open} width="50%">
      <Loading loading={loading} />
      <div style={{ padding: 15 }}>
        <h4>Incluir usuario na plataforma</h4>
        <Divider />
        <Grid container spacing={1}>
          <Grid item xs={7} sm={7}>
            <InputText
              type="text"
              value={data.nome ? data.nome : ""}
              onChange={(e) =>
                setData({
                  ...data,
                  nome: e.target.value
                    ? formatName(e.target.value)
                    : e.target.value,
                })
              }
              label="Nome Usuário"
            />
          </Grid>
          <Grid item xs={5} sm={5}>
            <InputText
              type="text"
              value={data.password}
              onChange={(e) => setData({ ...data, password: e.target.value })}
              label="Senha"
            />
          </Grid>
          <Grid item xs={7} sm={7}>
            <InputText
              type="email"
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
              label="E-mail"
            />
          </Grid>
          <Grid item xs={5} sm={5}>
            Tipo
          </Grid>
        </Grid>
        <br />
        <ButtonComponent onClick={() => AddCompany(200)} fullWidth>
          Inserir Usuário
        </ButtonComponent>
        <br />
        <ButtonComponent
          onClick={close}
          style={{ backgroundColor: "#3a3a3a" }}
          fullWidth
        >
          Fechar
        </ButtonComponent>

        <h4 style={{ color: "red", textAlign: "center" }}>{mesageErro}</h4>
      </div>
    </ModalComponent>
  );
}

export default ModalAddEmpresa;
